import PageLayout from 'pages/ProfileSetUp/PageLayout';
import PageProvider from 'pages/ProfileSetUp/PageProvider';

const ProfileSetUp = ({ ...props }) => {
    return (
        <PageProvider {...props}>
            <PageLayout />
        </PageProvider>
    );
};

export default ProfileSetUp;
